import Router from "next/router";
import React from "react";
import { reloadPage } from "../assets/js/utils/functions";
import { FrontPagesFooter } from "../components/front-pages/commons";
import ErrorDisplay from "../components/front-pages/error-display";
import FrontPagesLayout from "../components/front-pages/front-pages-layout";
import { AppBtn } from "../components/ui/buttons";
import ErrorScreen from "../components/ui/error-screen";
import PagesLoaderContext from "../contexts/page-loader-context";

const NotFound = () => {
  return (
    <PagesLoaderContext.Provider>
      <FrontPagesLayout hideAnimation>
        <main>
          <ErrorDisplay
            description={
              <>
                A problem occured on this page <br />
                our engineers have been notified
              </>
            }
            onClick={() => reloadPage()}
            btnCta="Reload Page"
          >
            Oops, something <br /> went wrong!
          </ErrorDisplay>
          <FrontPagesFooter />
        </main>
      </FrontPagesLayout>
    </PagesLoaderContext.Provider>
  );
};

export default NotFound;
